import utils from './utils'

let finalColour = 'green';
let finalColour2 = 'green';

let path_constant = 10;
let pathPoints = 0;
let dieChance = 0.001
let cut = false;
let maxChange = 5;
const waitTime = 6000;
const radius = 2;
const radiusRange = 4;
function randomGen(minimum,maximum){
    const return_rand = Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
    return return_rand ;
}

function distance (a,b){
    return Math.sqrt((a.x-b.x)*(a.x-b.x) + (a.y-b.y)*(a.y-b.y));
}

function length(a){
    return Math.sqrt(a.x*a.x+a.y*a.y);
}

function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
(function(w) {


    let canvas, ctx;

    let mouse = {
        x: 0,
        y: 0,
        px: 0,
        py: 0,
        down: false
    };

    let canvas_width ; //Needs to be a multiple of the resolution value below.
    let canvas_height ; //This too.

    let resolution = 10; //Width and height of each cell in the grid.

    let pen_size = 60; //Radius around the mouse cursor coordinates to reach when stirring

    let num_cols ; //This value is the number of columns in the grid.
    let num_rows;  //This is number of rows.

    let vec_cells = []; //The array that will contain the grid cells
    let particles = []; //The array that will contain the particles

    let backGround = null;  //The image to draw
    let animationLeftMargin = 0; //

    const PARTICLES_CONSTANT= 10000;    //Determines the number of particles. preferably 10*x

    let velocity=[];    //Each particle has start velocity

    function loadImageData(imageName){
        let canvas = document.createElement('canvas');
        let context = canvas.getContext('2d');
        let img = document.getElementById(imageName);
        canvas.width = img.width;
        canvas.height = img.height;

        context.drawImage(img, 0, 0 );

        //These lines get the canvas DOM element and canvas context, respectively.
        const width=img.width;
        const height = img.height;
        const imageData = context.getImageData(0,0, img.width, img.height)
        return {width, height, imageData};
    }
    function loadTextData(text){
        const width = 1400;
        const height= 200;

        let canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        let ctxLocal = canvas.getContext("2d");

        ctxLocal.fillStyle = "#2b532b";

        ctxLocal.font = "bold 75pt arial";
        ctxLocal.fillText(text,500,200);

        var imageData = ctxLocal.getImageData(0, 0, width, height);
        // Don;t forget to remove clear rectangle.
        //    ctx.putImageData(imageData, 0 ,0 );
        return {width, height, imageData};
    }
    function init(imageName, canvasWidth, canvasHeight){

        canvas = document.getElementById("c");
        ctx = canvas.getContext("2d");
        ctx.globalCompositeOperation='destination-over';
        const img = loadImageData(imageName);
        canvas_height = canvasHeight - canvasHeight%resolution;
        canvas_width = canvasWidth - canvasWidth%resolution;
        num_cols = canvas_width / resolution;
        num_rows = canvas_height / resolution;

        // Where does the mouse drag starts.
        animationLeftMargin = canvasWidth/2 - img.width/2;
        init_particles(img.imageData, img.height, img.width, canvas_width, canvas_height);


    }
    let ip;
    function set_ip(ipAddress) {
        ip = ipAddress;
    }
    function getCircleRadius(p1, p2) {
        return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2)  )/2
    }
    function getInfinityPath(start, width, height, constant) {

        const r1 = getCircleRadius({x: start.x + width, y: start.y}, {x: start.x+width, y: start.y + height})
        const x1 = start.x + width;
        const y1 = start.y + r1;

        const r2 = getCircleRadius(start, {x: start.x, y: start.y + height})
        const x2 = start.x;
        const y2 = start.y + r2;

        const retPath = [];
        retPath.push( { x: start.x, y: start.y });
        // Middle line till right circle
        for (let i = 1 ; i < constant ; i ++) {
            retPath.push( { x: start.x + ( width * i / constant), y: start.y + ( height * i / constant), });
        }
        //Right circle
        retPath.push( { x: start.x + width, y: start.y + height });
        for (let i = 1 ; i < constant + 1 ; i ++) {
            const angle = (90 - (180*i/( constant)) ) * Math.PI/180
            const x = r1 * Math.cos(angle) + x1;
            const y = r1 * Math.sin(angle) + y1;
            retPath.push( { x, y});
        }
        // Middle line till left circle
        for (let i = constant ; i > 1 ; i --) {
            retPath.push( { x: start.x + ( width * i / constant), y: start.y + ( height * (1 - (i / constant))), });
//            retPath.push( { x: start.x, y: start.y + height });
        }
        // left circle
        for (let i = 1 ; i < constant + 1 ; i ++) {
            const angle = (90 + (i * 180/( constant)) ) * Math.PI/180
            const x = r2 * Math.cos(angle) + x2;
            const y = r2 * Math.sin(angle) + y2;
            retPath.push( { x, y});
        }
        return retPath;
    }
    var infinityPath;
    function init_particles(imgData, c_height, c_width, canvasWidth, canvasHeight) {

        infinityPath = getInfinityPath({x:canvasWidth/3, y:canvasHeight/4}, canvasWidth/3, canvasHeight/4, path_constant)
        pathPoints = infinityPath.length
        const increase = Math.floor(imgData.data.length/PARTICLES_CONSTANT);
        for (let i = 0; i < imgData.data.length; i += +4 * increase) {

            if(imgData.data[i+3] !==0 ) {
                const x = (i / 4) % (c_width);
                const y = Math.floor((i / 4) / c_width);
                const target = {x:x+(canvasWidth-c_width)/2,y:y + 80};

                const colour = {r: imgData.data[i], g: imgData.data[i+1], b: imgData.data[i+2]};

                particles.push(new particle(randomGen(0,canvasWidth), randomGen(canvasHeight, 0), target, colour));
                velocity.push({vx: randomGen(1,3),vy: randomGen(1,3)});

            }
        }
        //This loops through the count of columns.
        for (let col = 0; col < num_cols; col++) {

            //This defines the array element as another array.
            vec_cells[col] = [];

            //This loops through the count of rows.
            for (let row = 0; row < num_rows; row++) {

                let cell_data = new cell(col * resolution, row * resolution, resolution)

                //This pushes the cell object into the grid array.
                vec_cells[col][row] = cell_data;

                /*
                These two lines set the object's column and row values so the object knows
                where in the grid it is positioned.
                */
                vec_cells[col][row].col = col;
                vec_cells[col][row].row = row;

            }
        }


        for (let col = 0; col < num_cols; col++) {

            for (let row = 0; row < num_rows; row++) {


                let cell_data = vec_cells[col][row];

                let row_up = (row - 1 >= 0) ? row - 1 : num_rows - 1;
                let col_left = (col - 1 >= 0) ? col - 1 : num_cols - 1;
                let col_right = (col + 1 < num_cols) ? col + 1 : 0;

                //Get the reference to the cell on the row above.
                let up = vec_cells[col][row_up];
                let left = vec_cells[col_left][row];
                let up_left = vec_cells[col_left][row_up];
                let up_right = vec_cells[col_right][row_up];

                /*
                Set the current cell's "up", "left", "up_left" and "up_right" attributes to the
                respective neighboring cells.
                */
                cell_data.up = up;
                cell_data.left = left;
                cell_data.up_left = up_left;
                cell_data.up_right = up_right;

                /*
                Set the neighboring cell's opposite attributes to point to the current cell.
                */
                up.down = vec_cells[col][row];
                left.right = vec_cells[col][row];
                up_left.down_right = vec_cells[col][row];
                up_right.down_left = vec_cells[col][row];

            }
        }





        //When the page is finished loading, run the draw() function.
        w.onload = draw;


    }

    /*
    calculate normalized vector of distance vector between two points
     */
    const min_velocity = 0.01
    function pDirection(a, b, i, cx, cy){
        function normalize(a,b){
            const c = {x:b.x-a.x, y:b.y-a.y};
            if(typeof i ==='undefined') return {x:((c.x/length(c))), y: (c.y/length(c))};

            if(distance(a,b) < Math.sqrt(Math.pow(velocity[i].vx, 2)+Math.pow(velocity[i].vy, 2))){
                const ratio = 0.5
                velocity[i].vx = velocity[i].vx * ratio < min_velocity ? min_velocity : velocity[i].vx * ratio
                velocity[i].vy = velocity[i].vy * ratio < min_velocity ? min_velocity : velocity[i].vy * ratio
            }
            return {x:((c.x/length(c)))* velocity[i].vx, y: (c.y/length(c)) *velocity[i].vy};
        }

        return normalize(a,b);
    }

    let allParticlesGreen;
    function update_circle() {
        //Loops through all of the particles in the array
        let allGreenFrame = true;
        for (let i = 0; i < particles.length; i++) {
            //Sets this letiable to the current particle so we can refer to the particle easier.
            let p = particles[i];
            allGreenFrame = p.colour === finalColour && allGreenFrame;
            //If the particle's X and Y coordinates are within the bounds of the canvas...
            if (p.x >= 0 && p.x < canvas_width && p.y >= 0 && p.y < canvas_height) {

                /*
               These lines divide the X and Y values by the size of each cell. This number is
               then parsed to a whole number to determine which grid cell the particle is above.
               */
                let col = parseInt(p.x / resolution);
                let row = parseInt(p.y / resolution);

                //Same as above, store reference to cell
                let cell_data = vec_cells[col][row];

                /*
                These values are percentages. They represent the percentage of the distance across
                the cell (for each axis) that the particle is positioned. To give an example, if
                the particle is directly in the center of the cell, these values would both be "0.5"

                The modulus operator (%) is used to get the remainder from dividing the particle's
                coordinates by the resolution value. This number can only be smaller than the
                resolution, so we divide it by the resolution to get the percentage.
                */
                let ax = (p.x % resolution) / resolution;
                let ay = (p.y % resolution) / resolution;

                /*
                These lines subtract the decimal from 1 to reverse it (e.g. 100% - 75% = 25%), multiply
                that value by the cell's velocity, and then by 0.05 to greatly reduce the overall change in velocity
                per frame (this slows down the movement). Then they add that value to the particle's velocity
                in each axis. This is done so that the change in velocity is incrementally made as the
                particle reaches the end of it's path across the cell.
                */
                p.xv += (1 - ax) * cell_data.xv * 0.05;
                p.yv += (1 - ay) * cell_data.yv * 0.05;

                /*
                These next four lines are are pretty much the same, except the neighboring cell's
                velocities are being used to affect the particle's movement. If you were to comment
                them out, the particles would begin grouping at the boundary between cells because
                the neighboring cells wouldn't be able to pull the particle into their boundaries.
                */
                p.xv += ax * cell_data.right.xv * 0.05;
                p.yv += ax * cell_data.right.yv * 0.05;

                p.xv += pDirection(p,p.target, i, p.xv, p.yv).x;
                p.yv += pDirection(p,p.target, i).y;

                p.x += p.xv;
                p.y += p.yv;

                //For each axis, this gets the distance between the old position of the particle and it's new position.

                let dx = p.px - p.x;
                let dy = p.py - p.y;

                //Using the Pythagorean theorum (A^2 + B^2 = C^2), this determines the distance the particle travelled.
                let dist = Math.sqrt(dx * dx + dy * dy);

                //This line generates a random value between 0 and 0.5
                let limit = Math.random() * 0.5;

                //If the distance the particle has travelled this frame is greater than the random value...
                // Drawing commet
                if ( distance(p, p.target) > 3) {

                        if (dist > limit) {
                        ctx.lineWidth = 2;
                        ctx.moveTo(p.x, p.y); //Move the drawing cursor to the starting point
                        ctx.lineTo(p.px, p.py);
                        ctx.strokeStyle = p.colour;
                        ctx.stroke(); //Draw the path to the canvas
                        ctx.beginPath(); //Begin a new path on the canvas
                    } else {
                        //If the particle hasn't moved further than the random limit...
                        ctx.moveTo(p.x, p.y);
                        /*
                        Describe a line from the particle's current coordinates to those same coordinates
                        plus the random value. This is what creates the shimmering effect while the particles
                        aren't moving.
                        */
                        ctx.lineTo(p.x + limit, p.y + limit);
                        ctx.strokeStyle = p.colour;
                        ctx.stroke();
                        ctx.beginPath();
                    }
                }
                else { // drawing circule
                    const duration = 0.2;
                    if (p.radius < p.futurRadius && p.dying === false) {
                        p.radius += duration;
                    } else {
                        p.dying = true;
                    }

                    if (p.dying === true) {
                        p.radius -= duration;
                    }
                    if (p.radius < 1 )
                        p.dying = false;
                    let dontDo = false;
                    if ((particles[i].colour === finalColour || particles[i].colour === finalColour2) && (changeCnt > imagesArrayLength || changeCnt >= maxChange)) {
                        particles[i].target.x = infinityPath[p.pathPoint].x;
                        particles[i].target.y = infinityPath[p.pathPoint].y;
                        particles[i].pathPoint += particles[i].pathDirection;
                        if(particles[i].pathDirection === 1) {
                            particles[i].colour = finalColour2;
                        }
                        if(particles[i].pathPoint > infinityPath.length - 1){
                            particles[i].pathPoint = 0;
                        }
                        if(particles[i].pathPoint < 0 ){
                            particles[i].pathPoint = infinityPath.length -1;
                        }
                        dontDo = true
                    } else if(Math.random() < dieChance) {
                        if(particles[i].colour === finalColour) {
                          // particles[i].target.y +=  + (Math.random() * 10)

                        } else {
                            if((changeCnt > imagesArrayLength || changeCnt >= maxChange)){
                                particles[i].target.x = infinityPath[p.pathPoint].x;
                                particles[i].target.y = infinityPath[p.pathPoint].y;
                            } else {
                            particles[i].target.y = utils.randomInt(canvas_height - 450, canvas_height - 250);
                            particles[i].target.x = utils.randomInt(100 , canvas_width-100);
                            }
                            particles[i].colour = finalColour;
                            velocity[i] = {vx: randomGen(1,1.5),vy: randomGen(1,3)}
                            dontDo = true

                        }

                    }
                    if(dontDo){
                    } else if(velocity[i].vx < 0.5 && velocity[i].vy < 0.5){
                        ctx.lineWidth = 1;
                        ctx.fillStyle = p.colour;
                        ctx.strokeStyle = p.colour;
                        ctx.arc(p.target.x, p.target.y, p.radius, 0, 2 * Math.PI);
                        ctx.fill();
                        ctx.stroke(); //Draw the path to the canvas
                        ctx.beginPath(); //Begin a new path on the canvas
                    }
                    }
                //This updates the previous X and Y coordinates of the particle to the new ones for the next loop.
                p.px = p.x;
                p.py = p.y;
            }
            else {
                //If the particle's X and Y coordinates are outside the bounds of the canvas...

                //Place the particle at a random location on the canvas
                p.x = p.px = Math.random() * canvas_width;
                p.y = p.py = Math.random() * canvas_height;


            }

            //These lines divide the particle's velocity in half everytime it loops, slowing them over time.
            p.xv *= 0.8;
            p.yv *= 0.8;
        }
        allParticlesGreen = allGreenFrame;
    }
    let updateParticle=false;

    /*
    This is the main animation loop. It is run once from the init() function when the page is fully loaded and
    uses RequestAnimationFrame to run itself again and again.
    */
    let debugCounter = 0;
    let startTimer, endTimer = 0
    let timer10, timer20, timer11, timer21, timer12, timer22;
    var d = new Date();
    var stop = false;
    var frameCount = 0;
    var fps, fpsInterval, startTime, now, then, elapsed;

    fpsInterval = 1000 / 30;
    then = Date.now();
    startTime = then;
    function draw() {
        now = Date.now();
        elapsed = now - then;

        // if enough time has elapsed, draw the next frame
        requestAnimationFrame(draw);

        if (elapsed < fpsInterval) {
            return;
        }
        then = now - (elapsed % fpsInterval);
        debugCounter+=1;

        if(debugCounter%10 ===0){
            startTimer =performance.now();
            timer10 =performance.now();
        }

        /*
        This calculates the velocity of the mouse by getting the distance between the last coordinates and
        the new ones. The coordinates will be further apart depending on how fast the mouse is moving.
        */
        let end = new Date().getTime();
        if(end - start > waitTime) {
            nextPage();
            start = end;
        }
        //Loops through all of the columns
        if(debugCounter%10 ===0){
            startTimer =performance.now();
        }
        for (let i = 0; i < vec_cells.length; i++) {
            let cell_datas = vec_cells[i];

            //Loops through all of the rows
            for (let j = 0; j < cell_datas.length; j++) {

                //References the current cell
                let cell_data = cell_datas[j];

                if (mouse.down && change.state || Math.abs(change.target.x - change.start.x)  > 20 || Math.abs(change.target.y - change.start.y)  > 20 ) {

                    change_cell_velocity_custom(cell_data, pDirection(change.start, change.target).x*100, pDirection(change.start, change.target).y*100, pen_size);
                    change.start.x += pDirection(change.start, change.target).x*0.005;
                    change.start.y += pDirection(change.start, change.target).y*0.005;

                }else if(change.state){
                    change = changes.pop();
                    change.update();
                }
                //This updates the pressure values for the cell.
                update_pressure(cell_data);
            }
        }
        if(debugCounter%10 ===0){
            //console.log("Update pressure"+performance.now());
        }
        /*
        This line clears the canvas. It needs to be cleared every time a new frame is drawn
        so the particles move. Otherwise, the particles would just look like long curvy lines.
        */
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if(backGround !== null)
            ctx.drawImage(backGround, (canvas.width-backGround.width)/2, (canvas.height-backGround.height) );

        //This sets the color to draw with.
        if(debugCounter%10 ===0){
            startTimer =performance.now();
        }
        //This calls the function to update the particle positions.

            update_circle();
        if(debugCounter%10 ===0){
            // console.log("Update particle"+performance.now());
        }
        /*
        This calls the function to update the cell velocity for every cell by looping through
        all of the rows and columns.
        */
        if(debugCounter%10 ===0){
            startTimer =performance.now();
        }

        for (let i = 0; i < vec_cells.length; i++) {
            let cell_datas = vec_cells[i];

            for (let j = 0; j < cell_datas.length; j++) {
                let cell_data = cell_datas[j];

                update_velocity(cell_data);

            }
        }
        if(debugCounter%10 ===0){
            // console.log("Update velocity"+performance.now());
        }
        //This replaces the previous mouse coordinates values with the current ones for the next frame.
        mouse.px = mouse.x;
        mouse.py = mouse.y;

        //This requests the next animation frame which runs the draw() function again.

    }



    /*
       This function changes the cell velocity of an individual cell by first determining whether the cell is
       close enough to the mouse cursor to be affected, and then if it is, by calculating the effect that mouse velocity
       has on the cell's velocity.
       */
    function change_cell_velocity_custom(cell_data, mvelX, mvelY, pen_size) {
        //This gets the distance between the cell and the mouse cursor.
        let dx = cell_data.x - change.start.x;
        let dy = cell_data.y - change.start.y;
        let dist = Math.sqrt(dy * dy + dx * dx);

        //If the distance is less than the radius...
        if (dist < pen_size) {

            //If the distance is very small, set it to the pen_size.
            if (dist < 4) {
                dist = pen_size;
            }

            //Calculate the magnitude of the mouse's effect (closer is stronger)
            let power = pen_size / dist;

            /*
            Apply the velocity to the cell by multiplying the power by the mouse velocity and adding it to the cell velocity
            */
            cell_data.xv += mvelX * power;
            cell_data.yv += mvelY * power;
        }
    }

    /*
    This function updates the pressure value for an individual cell using the
    pressures of neighboring cells.
    */
    function update_pressure(cell_data) {

        //This calculates the collective pressure on the X axis by summing the surrounding velocities
        let pressure_x = (
            cell_data.up_left.xv * 0.5 //Divided in half because it's diagonal
            + cell_data.left.xv
            + cell_data.down_left.xv * 0.5 //Same
            - cell_data.up_right.xv * 0.5 //Same
            - cell_data.right.xv
            - cell_data.down_right.xv * 0.5 //Same
        );

        //This does the same for the Y axis.
        let pressure_y = (
            cell_data.up_left.yv * 0.5
            + cell_data.up.yv
            + cell_data.up_right.yv * 0.5
            - cell_data.down_left.yv * 0.5
            - cell_data.down.yv
            - cell_data.down_right.yv * 0.5
        );

        //This sets the cell pressure to one-fourth the sum of both axis pressure.
        cell_data.pressure = (pressure_x + pressure_y) * 0.25;
    }


    /*
    This function updates the velocity value for an individual cell using the
    velocities of neighboring cells.
    */
    function update_velocity(cell_data) {

        /*
        This adds one-fourth of the collective pressure from surrounding cells to the
        cell's X axis velocity.
        */
        cell_data.xv += (
            cell_data.up_left.pressure * 0.5
            + cell_data.left.pressure
            + cell_data.down_left.pressure * 0.5
            - cell_data.up_right.pressure * 0.5
            - cell_data.right.pressure
            - cell_data.down_right.pressure * 0.5
        ) * 0.25;

        //This does the same for the Y axis.
        cell_data.yv += (
            cell_data.up_left.pressure * 0.5
            + cell_data.up.pressure
            + cell_data.up_right.pressure * 0.5
            - cell_data.down_left.pressure * 0.5
            - cell_data.down.pressure
            - cell_data.down_right.pressure * 0.5
        ) * 0.25;

        /*
        This slowly decreases the cell's velocity over time so that the fluid stops
        if it's left alone.
        */
        cell_data.xv *= 0.79;
        cell_data.yv *= 0.79;
    }


    //This function is used to create a cell object.
    function cell(x, y, res) {

        //This stores the position to place the cell on the canvas
        this.x = x;
        this.y = y;

        //This is the width and height of the cell
        this.r = res;

        //These are the attributes that will hold the row and column values
        this.col = 0;
        this.row = 0;

        //This stores the cell's velocity
        this.xv = 0;
        this.yv = 0;

        //This is the pressure attribute
        this.pressure = 0;

    }

    //This function is used to create a particle object.
    function particle(x, y, target, colour) {
        this.radius = 1.1;
        this.futurRadius = utils.randomInt(radius, radius + radiusRange);
        this.dying = false;
        this.colour = rgbToHex(colour.r,colour.g,colour.b);
        this.originalColour = rgbToHex(colour.r,colour.g,colour.b);
        this.pathPoint = parseInt(utils.randomInt(0, pathPoints-2));
        this.pathDirection = parseInt(utils.randomInt(0, 100)) % 2 === 0 ? 1 : -1;
        this.x = this.px = x;
        this.y = this.py = y;
        this.xv = this.yv = 0;
        this.target = {x: target.x,y: target.y};

    }


    /*
    This function is called whenever the mouse button is pressed. The event object is passed to
    this function when it's called.
    */
    let changes = [];
    function setChanges(){
        for (let i = 0 ; i < 5 ; i++){
            const up_y =  100;
            const left_x = animationLeftMargin-275;
            const right_x = left_x+ 800;
            let x;
            if(i===0){
                x = {state:false, start:{x:left_x,y:up_y},target:{x:right_x,y:up_y}, update: update_particle_target};
            }else
            if(i%2===0)
                x = {state:true, start:{x:left_x,y:up_y+i*100},target:{x:right_x,y:up_y+i*100}, update:function(){return null}};
            else
                x = {state:true, start:{x:right_x,y:up_y+i*100},target:{x:left_x,y:up_y+i*100}, update:function(){return null}};
            changes.push(x);
            changes.push(x);
        }
    }
    function setChanges2(){
        const hits = 5;
        for (let i = 0 ; i < hits ; i++){
            const up_y =  100;
            const left_x = animationLeftMargin;
            const right_x = left_x+ 500;
            let x;
            if(i===0){
                x = {state:false, start:{x:left_x,y:up_y},target:{x:right_x,y:up_y}, update: update_particle_target};
            }else
            if(i+1===hits)
                x = {state:true, start:{x:left_x+200,y:up_y - 100},target:{x:left_x+200,y:up_y+500}, update:function(){return null}};
            else if(i%2===0)
                x = {state:true, start:{x:left_x,y:up_y+i*100},target:{x:right_x,y:up_y+i*100}, update:function(){return null}};
            else
                x = {state:true, start:{x:right_x,y:up_y+i*100},target:{x:left_x,y:up_y+i*100}, update:function(){return null}};

            changes.push(x);
            changes.push(x);
        }
    }
    let imagesArray=['logoColorSmall','logo4','logoColorSmall','logo3','logoColorSmall','logo2'];
    let imagesArrayLength = imagesArray.length;
    let  start = new Date().getTime();
    function update_particle_target(){
        if(changeCnt===1 || changeCnt===5 ){
            const img = loadImageData('logoColorSmall');
            update_particle_image(img.imageData,img.width,80);

        }
        else{
            let img;
            if(changeCnt === 2)
                img = loadTextData("SORRY BUT...");
            else if(changeCnt === 3)
                img = loadTextData("WE LOVE YOU !");
            else if(changeCnt === 4)
                img = loadTextData(ip);

            update_particle_image(img.imageData, img.width, 200,20, 300);
        }
    }
    function update_particle_image(imgData, width, height, increaseMinus = 0, xDisplace = 0){
        const increase = Math.floor(imgData.data.length/PARTICLES_CONSTANT);
        let u = 0;
        while(u < particles.length){
            for (let i = 0; u < particles.length && i < imgData.data.length; i += 4 * increase - increaseMinus ) {
                if(imgData.data[i+3] !==0){
                    const x = (i / 4) % width;
                    const y = Math.floor((i / 4) / width);
                    const target = {x: (x+(canvas.width-width)/2) - xDisplace , y:y + height};

                    //  particles[u].colour = rgbToHex(colour.r,colour.g,colour.b);
                    particles[u].target = target;
                    velocity[u]={vx: randomGen(1,3),vy: randomGen(1,3)}

                    particles[u].colour = particles[u].originalColour;

                    u+=1;
                }


            }
        }
    }

    //let changes = [{state:false, start:{x:1000,y:1000},target:{x:1256,y:1700}}, {state:true, start:{x:700,y:1300},target:{x:1256, y:1700}}, {state:true, start:{x:700,y:1000},target:{x:1500,y:1200}}]
    let change = {state:false, start:{x:0,y:0},target:{x:0,y:0}};
    let changeCnt = 1;
    function nextPage(){
        if (cut) {
            return
        }
        if(changeCnt >= maxChange) {
            dieChance = 0.003
            return;
        }
        if(changeCnt%2!==0){
            //How the transformation will be
            setChanges2();
            change.state = true;
            change = changes.pop();
        }
        if(changeCnt%2===0){
            setChanges();
            change = changes.pop();

        }
        changeCnt +=1;
    }


    /*
    And this line attaches an object called "Fluid" to the global scope. "window" was passed into
    the self-invoking function as "w", so setting "w.Fluid" adds it to "window".
    */
    w.Fluid = {
        initialize: init,
        changeIp: set_ip,

    }

}(window)); //Passes "window" into the self-invoking function.


/*
Request animation frame polyfill. This enables you to use "requestAnimationFrame"
regardless of the browser the script is running in.
*/
window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;


//And this line calls the init() function defined above to start the script.
export default window.Fluid;